/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCutleryOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18 19.59 3.293 3.293 1.414-1.414-20-20-.53.531H2v.176l-.707.707L2 3.59V12a4.002 4.002 0 0 0 3 3.874V22h2v-6.126c1.725-.444 3-2.01 3-3.874v-.41l6 6V22h2zm-10-10V10H7V8.59zm-3-3V10H4V5.59zM6 14a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2zm14.66-.203a5.527 5.527 0 0 1-1.375 1.446l-1.452-1.452c.405-.205.806-.566 1.163-1.103.6-.9 1.004-2.201 1.004-3.688s-.404-2.788-1.004-3.688C18.392 4.405 17.666 4 17 4s-1.392.405-1.996 1.312C14.404 6.212 14 7.513 14 9c0 .352.023.694.065 1.023L12.05 8.007c.144-1.444.599-2.767 1.29-3.804C14.183 2.938 15.457 2 17 2s2.817.938 3.66 2.203C21.508 5.474 22 7.173 22 9c0 1.827-.492 3.526-1.34 4.797zM10 2v3.958l-2-2V2zM7 2v.958L6.042 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCutleryOff as CutleryOff };
